import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const CTA = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({
      title: 'Welcome aboard',
      description: `We’ll send early access details to ${email}.`,
    });
    setEmail('');
  };

  return (
    <section className="px-4 md:px-10 py-16">
      <div className="mx-auto max-w-[1240px] relative overflow-hidden rounded-3xl border border-emerald-800/60 bg-gradient-to-br from-[#0c2a1c] via-[#0a2016] to-[#08170f] p-8 md:p-14">
        <div className="absolute inset-0 grid-pattern opacity-40" />
        <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-emerald-500/15 blur-3xl" />
        <div className="absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />

        <div className="relative grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-emerald-800/70 bg-emerald-950/60 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-100">
              Get Early Access
            </div>
            <h2 className="mt-4 font-serif text-white text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Be the first to <span className="italic text-emerald-300">ride</span> the future.
            </h2>
            <p className="mt-3 text-emerald-100/70 max-w-md">
              Get member portal previews, cinematic drops and package unlocks straight to your inbox.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1">
              <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-emerald-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                className="w-full rounded-full bg-[#061810] border border-emerald-900/70 pl-11 pr-4 py-3.5 text-sm text-emerald-50 placeholder:text-emerald-100/40 focus:outline-none focus:border-emerald-500/60 focus:ring-2 focus:ring-emerald-500/20"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-medium px-6 py-3.5 transition"
            >
              Join Waitlist <ArrowRight size={16} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CTA;
